import React from 'react';
import {Typography} from '@material-ui/core';
import CustomTimeline, {CustomTimelineSeparator} from '../Timeline/Timeline';
import resumeData from '../../utils/resumeDate';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import Photo from '../../assets/images/photo.png';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineContent from '@material-ui/lab/TimelineContent';
import CustomButton from '../Button/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import useStyles from './style';

const CustomTimelineItem = ({title, text, link}) => {
  const classes = useStyles ();
  return (
    <TimelineItem>
      <CustomTimelineSeparator />
      <TimelineContent className={classes.timelineContent}>
        {link
          ? <Typography className={classes.timelineItemText}>
              <span className={classes.span}>{title} : </span> <a rel="noreferrer" className={classes.a} href={link} target="_blank">{text}</a>
            </Typography>
          : <Typography className={classes.timelineItemText}>
              <span className={classes.span}>{title} : </span>{text}
            </Typography>}
      </TimelineContent>
    </TimelineItem>
  );
};

const Profile = () => {
  const classes = useStyles ();

  return (
    <div className={classes.profile}>
      <div className={classes.profileName}>
        <Typography className={classes.name}> {resumeData.name} </Typography>
        <Typography className={classes.title}> {resumeData.title} </Typography>
      </div>

      <figure className={classes.profileImage}>
        <img className={classes.image} src={Photo} alt="Profile Pic" />
      </figure>

      <div className={classes.profileInformation}>
        <CustomTimeline icon={<PersonOutlineIcon/>}>
          <CustomTimelineItem title="Name" text={resumeData.name} />
          <CustomTimelineItem title="Birthday" text={resumeData.birthday} />
          <CustomTimelineItem title="Email" text={resumeData.email} />

          {Object.keys (resumeData.socials).map (key => (
            <CustomTimelineItem
              title={key}
              text={resumeData.socials[key].text}
              link={resumeData.socials[key].link}
            />
          ))}
        </CustomTimeline>

        <br />
        <div className={classes.btnContainer}>
          <a style={{textDecoration: "none"}} href="https://drive.google.com/file/d/130JQGRh-qFCXpFuMUQaGoEWe4WyMG8Be/view" target="_blank" download>
          <CustomButton text="Download Cv" icon={<GetAppIcon />} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Profile;
